import { useSelector } from 'react-redux';
import { getDevice } from '../selectors';

function useDevice(deviceId) {
  const device = useSelector(state => getDevice(state, deviceId));

  return { device };
}

export default useDevice;